import { BaseService, PagedResponse } from "./base";

interface PreviewResponse {
  pages: PreviewPageResponse[];
}

interface PreviewPageResponse {
  width: number;
  height: number;
  uri: string;
}

interface SlotsResponse {
  pages: SlotsPageResponse[];
}

interface SlotsPageResponse {
  width: number;
  height: number;
  slots: number[][];
}

interface AtividadeSlotRequest {
  coords: number[];
  resposta: string;
  grupo: number;
}

interface AtividadeSlotResponse {
  coords: number[];
  resposta: string;
  grupo: number;
}

interface AtividadeRequest {
  nome: string;
  ano: number;
  pdf?: string;
  pages: {
    width: number;
    height: number;
    slots: AtividadeSlotRequest[];
  }[];
}

export interface AtividadeSearchResponse {
  id: string;
  nome: string;
  ano: number;
}

export interface AtividadeResponse {
  nome: string;
  ano: number;
  audio?: string;
  audioAt?: string;
  pdf?: string;
  pdfAt?: string;
  pages?: {
    width: number;
    height: number;
    uri: string;
    slots: AtividadeSlotResponse[];
  }[];
}

class AtividadesService extends BaseService {
  constructor() {
    super("atividades");
  }

  previewPdf(pdfUri: string): Promise<PreviewResponse> {
    return this.post("previa", { uri: pdfUri });
  }

  getMaskSlots(maskUri: string): Promise<SlotsResponse> {
    return this.post("mascara", { uri: maskUri });
  }

  create(item: AtividadeRequest): Promise<void> {
    return this.post("", item);
  }

  update(id: string, item: AtividadeRequest): Promise<void> {
    return this.put(id, item);
  }

  search(): Promise<PagedResponse<AtividadeSearchResponse>> {
    return this.get("");
  }

  read(id: string): Promise<AtividadeResponse> {
    return this.get(id);
  }

  remove(id: string): Promise<void> {
    return this.delete(id);
  }
}

export default new AtividadesService();
